const INITIAL_GLOBAL_STATE = {
  activePlanet: -1,
};

const ACTION_TYPES = {
  SET_ACTIVE_PLANET: "SET_ACTIVE_PLANET",
};

export { INITIAL_GLOBAL_STATE, ACTION_TYPES };
